/* ================================================================
   Premium polish — micro-interacciones de tarjeta de producto.
   Solo desktop con mouse. Se apaga solo si el usuario prefiere menos
   movimiento o si estamos dentro del Theme Editor.

   Nota: no se usa scroll suave (Lenis) porque secuestraba el scroll
   dentro de la sección de video, ni cursor custom, ni botones
   magnéticos — se probaron y se descartaron.
   ================================================================ */
(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const inThemeEditor = !!(window.Shopify && window.Shopify.designMode);

  if (prefersReducedMotion || inThemeEditor || !isDesktopPointer) return;
  if (typeof window.gsap === 'undefined') return;

  /* ---------------------------------------------------------------
     Tilt 3D + lift en tarjetas de producto: la imagen se inclina
     siguiendo el cursor y la tarjeta se eleva. Delegado en document
     para que funcione también con tarjetas que el tema carga después
     (carruseles, recomendados, quick-shop).
     --------------------------------------------------------------- */
  const tiltSetters = new WeakMap();

  function getTiltSetters(card, image) {
    if (!tiltSetters.has(card)) {
      card.style.perspective = '700px';
      tiltSetters.set(card, {
        rx: gsap.quickTo(image, 'rotateX', { duration: 0.4, ease: 'power3' }),
        ry: gsap.quickTo(image, 'rotateY', { duration: 0.4, ease: 'power3' }),
        scale: gsap.quickTo(image, 'scale', { duration: 0.4, ease: 'power3' }),
        lift: gsap.quickTo(card, 'y', { duration: 0.4, ease: 'power3' }),
      });
    }
    return tiltSetters.get(card);
  }

  document.addEventListener(
    'mousemove',
    (e) => {
      const card = e.target.closest('.grid-view-item');
      if (!card) return;
      const image = card.querySelector('.grid-view-item-image');
      if (!image) return;
      const rect = image.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width - 0.5;
      const py = (e.clientY - rect.top) / rect.height - 0.5;
      const { rx, ry, scale, lift } = getTiltSetters(card, image);
      ry(px * 16);
      rx(py * -16);
      scale(1.04);
      lift(-8);
    },
    { passive: true }
  );

  document.addEventListener('mouseout', (e) => {
    const card = e.target.closest('.grid-view-item');
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    const image = card.querySelector('.grid-view-item-image');
    if (!image || !tiltSetters.has(card)) return;
    const { rx, ry, scale, lift } = tiltSetters.get(card);
    rx(0);
    ry(0);
    scale(1);
    lift(0);
  });

  /* ---------------------------------------------------------------
     Feedback al agregar al carrito — bump del contador cuando se abre
     el drawer (el tema emite 'open:cart:drawer' al agregar, ver theme.js).
     --------------------------------------------------------------- */
  if (window.eventBus) {
    window.eventBus.on('open:cart:drawer', () => {
      const counters = document.querySelectorAll('[data-cart-count-indicator]');
      if (!counters.length) return;
      gsap.fromTo(
        counters,
        { scale: 1 },
        {
          scale: 1.35,
          duration: 0.18,
          ease: 'power2.out',
          yoyo: true,
          repeat: 1,
          transformOrigin: '50% 50%',
        }
      );
    });
  }
})();
